import { Injectable, computed, inject } from '@angular/core';
import { HuntPackageDetailUiStateService } from '../hunt-package-details/services/HuntPackageDetailUiStateService';
import { HuntEditorStoreService } from './huntEditorStoreService';

@Injectable({ providedIn: 'root' })
export class QueryActiveHuntPackageQueryService {
  private readonly ui = inject(HuntPackageDetailUiStateService);
  private readonly editor = inject(HuntEditorStoreService);

  // ✅ Selected query by ID/index combo (e.g., "toolId::0")
  readonly selectedQuery = computed(() => {
    const id = this.ui.selectedQueryId();
    if (!id) return null;
  
    const [toolId, queryIndexStr, pivotIndexStr] = id.split('::');
    const queryIndex = parseInt(queryIndexStr, 10);
    const pivotIndex = pivotIndexStr !== undefined ? parseInt(pivotIndexStr, 10) : null;
  
    if (isNaN(queryIndex)) return null;
  
    const tool = this.editor.getAllTools().find(t => t.id === toolId);
    if (!tool) return null;
  
    const baseQuery = tool.generatedContent.Hunt?.[queryIndex];
    if (!baseQuery) return null;
  
    // 🔁 Pivot query
    if (pivotIndex !== null && !isNaN(pivotIndex)) {
      return baseQuery.pivots?.[pivotIndex] ?? null;
    }
  
    // ✅ Normal base query
    return baseQuery;
  });

  readonly selectedPivotIndex = computed(() => {
    const id = this.ui.selectedQueryId();
    if (!id) return null;
  
    const parts = id.split('::');
    if (parts.length < 3) return null;
  
    const pivotIndex = parseInt(parts[2], 10);
    return isNaN(pivotIndex) ? null : pivotIndex;
  });
  

  readonly isPivotQuery = computed(() => {
    const id = this.ui.selectedQueryId();
    if (!id) return false;
    return id.split('::').length === 3;
  });
  
  
  readonly selectedTool = computed(() => {
    const id = this.ui.selectedQueryId();
    if (!id) return null;

    const [toolId] = id.split('::');
    return this.editor.getAllTools().find(t => t.id === toolId) ?? null;
  });

  readonly selectedQueryIndex = computed(() => {
    const id = this.ui.selectedQueryId();
    if (!id) return null;

    const [, indexStr] = id.split('::');
    const index = parseInt(indexStr, 10);
    return isNaN(index) ? null : index;
  });
}
